import React from 'react';
import { motion } from 'framer-motion';

export default function Hero() {
  return (
    <section className="text-center max-w-5xl mx-auto px-4 mb-12 md:mb-20">
      <motion.div 
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        <div className="inline-flex items-center gap-2 py-2 px-5 rounded-full bg-gradient-badge text-white text-[10px] md:text-xs font-bold mb-8 md:mb-12 uppercase tracking-[0.2em] shadow-lg shadow-brand-pink/20">
          <span className="relative flex h-2 w-2">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-white opacity-75"></span>
            <span className="relative inline-flex rounded-full h-2 w-2 bg-white"></span>
          </span>
          Member Training
        </div>

        <h1 className="text-5xl md:text-7xl lg:text-8xl font-bold text-white mb-8 md:mb-10 tracking-tight leading-[1.1]">
          Your <span className="text-transparent bg-clip-text bg-gradient-brand">Buying Trade</span> Guide
        </h1>
        
        <p className="text-lg md:text-xl lg:text-2xl text-text-body mb-10 md:mb-14 max-w-3xl mx-auto leading-relaxed px-2">
          Master high-probability entries and precision exit strategies using our interactive AI-driven walkthrough.
        </p>

        <div className="flex items-center justify-center gap-6 md:gap-16 pt-4 px-2">
          <div className="flex flex-col items-center">
            <span className="text-xl md:text-3xl font-bold text-white">BUY</span>
            <span className="text-[9px] md:text-[11px] text-brand-secondary uppercase tracking-[0.25em] font-bold mt-1">Signals</span>
          </div>
          <div className="w-px h-10 md:h-12 bg-white/10"></div>
          <div className="flex flex-col items-center">
            <span className="text-xl md:text-3xl font-bold text-white">CONFIRM</span>
            <span className="text-[9px] md:text-[11px] text-brand-secondary uppercase tracking-[0.25em] font-bold mt-1">Filters</span>
          </div>
          <div className="w-px h-10 md:h-12 bg-white/10"></div>
          <div className="flex flex-col items-center">
            <span className="text-xl md:text-3xl font-bold text-white">PROFIT</span>
            <span className="text-[9px] md:text-[11px] text-brand-secondary uppercase tracking-[0.25em] font-bold mt-1">Targets</span>
          </div>
        </div>
      </motion.div>
    </section>
  );
}